export const ImageType = Object.freeze({
    M: Symbol('M'),
    H: Symbol('H'),
    S: Symbol('S'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(value = 'value', text = 'text') {
    let items = [];
    const types = Object.getOwnPropertyNames(ImageType);

    for (const type of types) {
        items.push({[value]: type, [text]: getTypeText(type)});
    }

    return items;
}

export function getTypeText(type) {
    return {
        [ImageType.M]: 'Główny',
        [ImageType.H]: 'Nagłówek',
        [ImageType.S]: 'Slider',
    }[ImageType[type]];
}